import { Router } from '@angular/router';
import { BehaviorSubject, Observable, Subject, from, throwError } from 'rxjs';
import { map, catchError, tap, switchMap } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { SharedService } from './shared.service'
import { isNullOrUndefined } from 'util';
import { stringify } from '@angular/compiler/src/util';

@Injectable({
	providedIn: 'root'
})
export class AuthService {
	constructor(
		private router: Router,
		private http: HttpClient,
		private sharedService: SharedService
	) { }
	public urlUser = '';
	public changeLoginStatusSubject = new Subject<boolean>();
	public changeLoginStatus = this.changeLoginStatusSubject.asObservable();

	public loginUser(credential: any): Observable<any> {

		//var result = await this.authService.LoginOk({ email: this.model.email, password: this.model.password }).toPromise();

		//return this.http.post<any>(this.sharedService.Get_APIURL() +"/auth/login" , credential).pipe(
		return this.http.post<any>(this.sharedService.Get_APIURL() + "/auth/login", credential).pipe(
			switchMap((result: any) => {
				console.log("result");
				console.log(result);
				let token = "";
				if (typeof result !== 'undefined' && result.error == false) {
					token = result.token;
					// this.setToken(token);
					// this.setUserData({A:"", Permissions:[{_id:"1"}]});
					// this.setCurrentCompany({A:""});
					var permisos = [];
					for (var i = 0; i < result.data.Permissions.length; i++) {
						if (result.data.Permissions[i].isActive) {
							permisos.push(result.data.Permissions[i].Service)
						}
					}
					this.setToken(token);
					this.setUserData(result.data);
					this.setUserRoles(permisos);

					this.setCurrentCompany({ currentCompany: result.data.SusbscriberName, _id: result.data.IdSubscriber });
					return [{ error: false, user: true }];


				} else {

					return [{ error: true, message: result.message }];
					//	return [{ error: false, user: false }];
				}

			}),
			catchError(this.handleError('login', [{ user: false, error: true }]))
		);
	}


	public registerUser(register: any): Observable<any> {

		return this.http.post<any>(this.sharedService.Get_APIURL() + "/auth/signup", register).pipe(
			switchMap((result: any) => {
				let token = "";
				if (typeof result !== 'undefined') {
					// token = result.token;
					// this.setToken(token);
					// this.setUserData(result.generalinfo);
					// this.setCurrentCompany(result.generalinfo.Customers[0]);
					return [result];


				} else {

					return [{ error: true, message: "communication error" }]
				}

			}),
			catchError(this.handleError('register', [{ user: false, error: true }]))
		);
	}

	public resendConfirmation(register: any): Observable<any> {

		return this.http.post<any>(this.sharedService.Get_APIURL() + "/auth/resendemailconfirmation", register).pipe(
			switchMap((result: any) => {
				let token = "";
				if (typeof result !== 'undefined') {
					// token = result.token;
					// this.setToken(token);
					// this.setUserData(result.generalinfo);
					// this.setCurrentCompany(result.generalinfo.Customers[0]);
					return [result];


				} else {

					return [{ error: true, message: "communication error" }]
				}

			}),
			catchError(this.handleError('register', [{ user: false, error: true }]))
		);
	}

	public forgotPassword(register: any): Observable<any> {

		return this.http.post<any>(this.sharedService.Get_APIURL() + "/auth/forgot", register).pipe(
			switchMap((result: any) => {
				let token = "";
				if (typeof result !== 'undefined') {
					// token = result.token;
					// this.setToken(token);
					// this.setUserData(result.generalinfo);
					// this.setCurrentCompany(result.generalinfo.Customers[0]);
					return [result];


				} else {

					return [{ error: true, message: "communication error" }]
				}

			}),
			catchError(this.handleError('register', [{ user: false, error: true }]))
		);
	}

	/**
		 * Handle Http operation that failed.
		 * Let the app continue.
		 * @param operation - name of the operation that failed
		 * @param result - optional value to return as the observable result
		 */
	private handleError<T>(operation = 'operation', result?: any) {
		return (error: any): Observable<any> => {
			//	console.log(operation);
			//	console.log(error);
			// TODO: send the error to remote logging infrastructure
			//	console.error(error); // log to console instead

			// Let the app keep running by returning an empty result.
			if (error.includes('429')) {
				let errorMessage = [];
				errorMessage.push({ error: true, user: false, message: 'Too many requests, please try later.', status: '429' })
				return from(errorMessage);
			}
			else {
				let errorMessage = [];
				errorMessage.push({ error: true, user: false, message: error.message, status: error.status })
				return from(errorMessage);
			}
		};
	}

	setToken(token) {
		localStorage.setItem('accessToken', token);
	}

	getToken() {
		return localStorage.getItem('accessToken');
		// let token_string = localStorage.getItem('accessToken');
		// if (!isNullOrUndefined(token_string)) {
		// 	let token = JSON.parse(token_string);
		// 	return token;
		// } else {
		// 	return null;
		// }

	}

	setUserData(user) {
		let user_string = JSON.stringify(user);
		localStorage.setItem('userData', user_string);
	}

	setUserRoles(roles) {
		let roles_string = JSON.stringify(roles);
		localStorage.setItem('userRoles', roles_string);
	}

	// public setUserRoles(roles: any): any {
	// 	if (roles != null) {
	// 		localStorage.setItem('userRoles', JSON.stringify(roles));
	// 	}

	// 	return this;
	// }

	getUserData() {
		let user_string = localStorage.getItem('userData');
		if (!isNullOrUndefined(user_string)) {
			let user = JSON.parse(user_string);
			return user;
		} else {
			return null;
		}
	}

	getUserPermissions() {
		let user_string = localStorage.getItem('userData');
		if (!isNullOrUndefined(user_string)) {
			let user = JSON.parse(user_string);
			return user.Permissions;
		} else {
			return null;
		}
	}

	logoutUser() {
		localStorage.clear();
		let info_string = JSON.stringify({
			"FirstName": "",
			"LastName": ""
		});
		localStorage.setItem('userData', info_string);
		this.router.navigate(['/login']);
	}

	adminprofile() {
		this.router.navigate(['/admin/profile']);
	}

	isLoggedIn(url: string) {
		const islogged = localStorage.getItem('accessToken');
		if (!islogged) {
			this.urlUser = url;
			return false;
		}
		return true;
	}

	urlhasPermission(url: string) {
		// let returnpermission = false;
		// let Permissions  =  [];
		// Permissions = this.getUserPermissions();
		// Permissions.forEach(permission => {
		// 	console.log(permission.Service);
		// 	if (url == permission.Service && permission.Permanent == true){
		// 		returnpermission = true;
		// 	}
		// });
		return true;
	}

	setCurrentCompany(Company) {
		if (!Company) {
			Company = {};
		}
		let company_string = JSON.stringify(Company);
		localStorage.setItem('currentCompany', company_string);
	}

	getCurrentCompany() {
		let userData = localStorage.getItem('currentCompany');
		if (!isNullOrUndefined(userData)) {
			let company = JSON.parse(userData);
			return company;
		} else {
			return null;
		}
	}

	getCustomers() {
		let userData = localStorage.getItem('userData');
		if (!isNullOrUndefined(userData)) {
			let customers = JSON.parse(userData);
			return customers.Customers;
		} else {
			return null;
		}
	}

}
